var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutUs1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7243 10.4511L17.5296 9.35612L14.3133 2.5282C14.2255 2.34126 14.081 2.18992 13.9024 2.09793C13.4547 1.86648 12.9106 2.05936 12.6868 2.5282L9.47055 9.35612L2.27582 10.4511C2.07746 10.4808 1.89611 10.5787 1.75725 10.727C1.58939 10.9077 1.49689 11.1508 1.50008 11.4028C1.50327 11.6549 1.60188 11.8953 1.77426 12.0713L6.97974 17.3858L5.74992 24.8903C5.72108 25.0649 5.73953 25.2444 5.80317 25.4086C5.86681 25.5727 5.97311 25.7149 6.10999 25.819C6.24688 25.9231 6.40889 25.985 6.57764 25.9976C6.74639 26.0102 6.91514 25.973 7.06475 25.8903L13.5001 22.3473L19.9354 25.8903C20.111 25.9882 20.3151 26.0209 20.5106 25.9853C21.0037 25.8962 21.3352 25.4066 21.2502 24.8903L20.0204 17.3858L25.2259 12.0713C25.3675 11.9259 25.4611 11.736 25.4894 11.5282C25.5659 11.0089 25.2202 10.5282 24.7243 10.4511Z",
    fill: "#026BB5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs1);
export default __webpack_public_path__ + "static/media/about-us1.faa54708e891d3f79be78cd1cf5cc858.svg";
export { ForwardRef as ReactComponent };